export default {
  add_products: '+ Lisää tuotteita',
};
